<div>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">تغییر رمز عبور کارشناس</h2>
            </div>

            <div class="modal-body">
                <h2>اطلاعات خود را وارد کنید</h2>

                <form #ngForm="ngForm" (ngSubmit)="submit(ngForm)">
                    <div class="form-group has-icon">
                        <span class="form-control-icon">
                            <mat-icon>password</mat-icon>
                        </span>
                        <input type="search" class="form-control" name="oldPasswordField" id="oldPasswordField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strOldPassword" required placeholder="رمز عبور قدیمی" autofocus />
                    </div>

                    <div class="form-group has-icon">
                        <span class="form-control-icon">
                            <mat-icon>password</mat-icon>
                        </span>
                        <input type="search" class="form-control" name="newPasswordField" id="newPasswordField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strNewPassword" required placeholder="رمز عبور جدید" />
                    </div>

                    <div class="form-group has-icon">
                        <span class="form-control-icon">
                            <mat-icon>password</mat-icon>
                        </span>
                        <input type="search" class="form-control" name="newPasswordRepeatField" id="newPasswordRepeatField" [disabled]="isSubmitDisabled" [(ngModel)]="fields.strNewPasswordRepeat" required placeholder="تکرار رمز عبور جدید" />
                    </div>
                </form>
            </div>

            <div class="modal-footer d-flex flex-row-reverse justify-content-start">
                <button type="button" class="btn btn-primary" [disabled]="ngForm.invalid || ngForm.pristine || isSubmitDisabled" (click)="ngForm.ngSubmit.emit()">تغییر رمز عبور</button>
            </div>
        </div>
    </div>
</div>